var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modalJobInfo",
      attrs: {
        id: "modalJobInfo",
        title: "Status for Job #" + _vm.job.id,
        size: "xl",
        "ok-only": "",
      },
      on: { hidden: _vm.killTimer },
    },
    [
      _vm._l(_vm.messages, function (message) {
        return _c(
          "b-alert",
          {
            key: message.text,
            attrs: {
              show: message.countdown || true,
              fade: "",
              dismissible: "",
              variant: message.variant || "danger",
            },
          },
          [_vm._v(_vm._s(message.text))]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Title"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(_vm._s(_vm.job.title)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Status"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(_vm._s(_vm.job.status)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Started"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(_vm._s(_vm.formatDate(_vm.job.startTime))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Started By"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(
                _vm._s(_vm.job.startedByFullName) +
                  " [" +
                  _vm._s(_vm.job.startedById) +
                  "]"
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Ended"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(_vm._s(_vm.formatDate(_vm.job.endTime))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "col-sm-4 font-weight-bold" }, [
              _vm._v("Updated"),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "col-sm-8" }, [
              _vm._v(_vm._s(_vm.formatDate(_vm.job.lastMessageTime))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("pre", { domProps: { innerHTML: _vm._s(_vm.jobMessages) } }),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }